module.exports = __webpack_public_path__ + "img/icon-inquiry-bundle.151ee43d.svg";